module.exports = __webpack_public_path__ + "img/icon-yae-miko.ead6c7c5.webp";